import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    lastStep: 'truncate',
    item: 'shrink-0 truncate',
    wrapper: 'body-5 flex items-center gap-x-1'
  },
  iconSize: 'md',
  linkVariant: 'quiet',
  separatorIcon: 'chevron',
  showFirstStepIcon: false,
  allowFullBreadcrumbsOnMobile: true
} satisfies RecursivePartial<VfConfig['breadcrumbs']>
